import { render, staticRenderFns } from "./Variable.vue?vue&type=template&id=573c273c&"
import script from "./Variable.vue?vue&type=script&lang=ts&"
export * from "./Variable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports